import { all } from "redux-saga/effects";

import { watchResetPassword } from "./resetPassword";
import { watchResetPasswordEmail } from "./resetPasswordEmail";

export function* rootSaga() {
  yield all([watchResetPassword(), watchResetPasswordEmail()]);
}
